import { useState, useCallback } from 'react';
import { apkStorage } from 'store/storage';


const EXPIRE_MS = 24 * 60 * 60 * 1000; // 24 hours

const useApkState = (defaultValue: boolean = false) => {
    const [state, setState] = useState<boolean>(() => {
        const raw = apkStorage.get();
        if (!raw) return defaultValue;

        try {
            const { value, timestamp } = JSON.parse(raw);
            if (Date.now() - timestamp > EXPIRE_MS) {
                apkStorage.remove();
                return defaultValue;
            }
            return value === 'true';
        } catch {
            apkStorage.remove();
            return defaultValue;
        }
    });

    const setApkState = useCallback(
        (value: boolean | ((prev: boolean) => boolean)) => {
            setState((prev) => {
                const newValue = typeof value === 'function' ? value(prev) : value;

                const dataToStore = {
                    value: newValue.toString(),
                    timestamp: Date.now()
                };
                apkStorage.set(JSON.stringify(dataToStore));

                return newValue;
            });
        },
        []
    );

    const hideFor24Hours = useCallback(() => {
        const dataToStore = {
            value: 'false',
            timestamp: Date.now()
        };
        apkStorage.set(JSON.stringify(dataToStore));
        setState(false);
    }, []);

    return [state, setApkState, hideFor24Hours] as const;
};

export default useApkState;
